import {Input} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {Controller, DISABLE_AUTOCOMPLETE, useFormContext} from '@yandex-delivery/form'
import React from 'react'

import type {FloorInputProps} from './FloorInput.types'

export function FloorInput({name, 'data-testid': dataTestId}: FloorInputProps): React.ReactElement {
  const t = useI18n()
  const {control} = useFormContext()

  return (
    <Controller
      control={control}
      defaultValue=""
      name={name}
      render={({field, fieldState}) => (
        <div ref={field.ref}>
          <Input
            autoCapitalize="none"
            autoComplete={DISABLE_AUTOCOMPLETE}
            data-testid={dataTestId}
            error={fieldState.invalid}
            helperText={fieldState.error?.message}
            label={t('cargo.create.address.sfloor', 'Этаж')}
            name={name}
            onBlur={field.onBlur}
            onChange={field.onChange}
            size="l"
            spellCheck="false"
            value={field.value?.toString()}
            variant="line"
          />
        </div>
      )}
    />
  )
}
